module.exports = __webpack_public_path__ + "img/christiane-sohn.0f9c495f.jpg";